export default "__VITE_ASSET__CIG3Gk23__"